import { render } from "./ShortRedirect.vue?vue&type=template&id=dac75c24"
import script from "./ShortRedirect.vue?vue&type=script&lang=js"
export * from "./ShortRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__